import CategoriesListComponent from './CategoriesListComponent';

export default CategoriesListComponent;
